import { css, Styles, verticalScrollCss, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  dialog: css`
    z-index: 3;
  `,
  content: css`
    padding: 0;
    width: calc(520px + 48px);
    max-height: 90vh;
  `,
  animationContainer: css`
    position: relative;
  `,
  body: css`
    position: relative;
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    max-height: 100%;
  `,
  bodyHeader: css`
    display: flex;
    width: 100%;
    align-items: center;
    padding: 12px 24px;
  `,
  bodyContent: css`
    display: flex;
    flex-direction: column;
    overflow: hidden;

    transition: all 2s ease-in-out;
  `,
  stepContainer: ({ theme }) => css`
    display: flex;
    flex-direction: column;
    max-height: 100%;
    overflow: hidden auto;

    padding: 0px 12px 12px 24px;
    margin-right: 12px;
    margin-bottom: 12px;

    ${verticalScrollCss(theme)}
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
